import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum, StatementFile, StatementsApi } from '@shared/api';
import { FileUtils } from '@shared';

interface IDownloadStatementStore {
  loading: boolean;
  error: string | null;
  statementFile: StatementFile | null;
  downloadStatement: (request: { statementId: string; filename?: string }, isPreview?: boolean, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadStatementStore = create<IDownloadStatementStore>((set) => ({
  loading: false,
  error: null,
  statementFile: null,

  downloadStatement: ApiUtils.wrapperApi(async (request: { statementId: string; filename?: string }, isPreview?: boolean, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await StatementsApi.downloadStatement(request.statementId, signal);
      !isPreview && FileUtils.downloadFile(result.data, request.filename);
      set({ statementFile: isPreview ? (result ?? null) : null, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ statementFile: null, loading: false, error: null }),
}));
